<div class="page  page--dashboard" #pageDashboard>
  <div [@displayDashboard]="dashboardState" class="page__container">
    <h1 class="page__title h2">
      {{ 'dashboard_title_welcome' | translate }} <span>{{ getUserName }}</span>
    </h1>
    <div class="dashboard-toastr-container">
      <div class="toastr-relative toastr-sm toastr-no-shadow my-4" toastContainer></div>
    </div>

    <div class="row my-5">
      <div class="col-6 col-lg-3 mb-4">
        <wsb-ui-card
          title="{{ 'dashboard_box_sms_title' | translate }}"
          type="choice_card_a"
          [routerLink]="user?.account.canSendOnlyToRegistrationNumber ? ['/sms/sendTrial'] : ['/sms/send']"
        >
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-msg-sms.svg'"></p>
          <div wsb-ui-card-footer>
            <span [innerHTML]="'dashboard_box_sms_text' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
      <div class="col-6 col-lg-3 mb-4">
        <wsb-ui-card title="{{ 'dashboard_box_contacts_title' | translate }}" type="choice_card_a" routerLink="/contacts/list">
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-contacts.svg'"></p>
          <div wsb-ui-card-footer>
            <span [innerHTML]="'dashboard_box_contacts_text' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
      <div class="col-6 col-lg-3 mb-4">
        <wsb-ui-card title="{{ 'dashboard_box_stats_title' | translate }}" type="choice_card_a" routerLink="/stats/sms">
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-stats.svg'"></p>
          <div wsb-ui-card-footer>
            <span [innerHTML]="'dashboard_box_stats_text' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
      <div *ngIf="showShop" class="col-6 col-lg-3 mb-4">
        <wsb-ui-card title="{{ 'dashboard_box_shop_title' | translate }}" type="choice_card_a" routerLink="/shop/index">
          <p class="py-2" [inlineSVG]="'assets/images/icons/icon-credits.svg'"></p>
          <div wsb-ui-card-footer>
            <span [innerHTML]="'dashboard_box_shop_text' | translate"></span>
          </div>
        </wsb-ui-card>
      </div>
    </div>

    <div *ngIf="showSenderBanner" class="w-100 mb-5">
      <a href="{{ senderAppBannerLink }}" target="_blank" rel="noopener">
        <img class="w-100" [src]="senderBanner" />
      </a>
    </div>

    <div *ngIf="showBanner" class="w-100 mb-5">
      <a href="{{ whatsAppBannerLink }}">
        <img class="w-100" [src]="banner" />
      </a>
    </div>

    <div *ngIf="showHelp">
      <h3 class="mt-1" translate>dashboard_need_help</h3>
      <div class="row my-3">
        <div class="col">
          <a target="_blank" *ngIf="hasSupportGuideUrl" [href]="'support_guide_url' | translate"
            ><wsb-atlas-button class="mb-2" [label]="'dashboard_browse_guide'">{{
              'dashboard_browse_guide' | translate
            }}</wsb-atlas-button></a
          >
          <wsb-atlas-button variant="link" class="mb-2 ms-3" [label]="'dashboard_contact_us'" routerLink="/support">{{
            'dashboard_contact_us' | translate
          }}</wsb-atlas-button>
        </div>
      </div>
    </div>
  </div>
</div>
